import { gql } from 'apollo-boost';

export const TICKET_DEFINITIONS: any = gql`
  query TicketDefinitions($id: UUID, $slug: String) {
    event(id: $id, slug: $slug) {
      ticketStart
      ticketEnd
      ticketDefinitions {
        id
        name
        sortIndex
        description
        price
        quantity: remainingCount
        showRemainingQuantity
      }
    }
  }
`;

export const ORDER_CLAIMS: any = gql`
  query OrderClaims($id: UUID!) {
    order(id: $id) {
      claims {
        id
        ticketDefinition {
          id
        }
      }
    }
  }
`;

export const EVENT: any = gql`
  query Event($id: UUID, $slug: String, $draftOnly: Boolean) {
    event(id: $id, slug: $slug, draftOnly: $draftOnly) {
      id
      name
      slug
      templateVersion
      eventStart
      eventEnd
      eventTimezone
      enableCheckoutDonation
      webUrl
      capacity
      hostName
      hostEmail
      summary
      description
      terms
      ticketStart
      ticketEnd
      isPrivate
      posterMode
      posterUrl
      coverImageUrl
      mainLogoImageUrl
      taxNumber
      enableTax
      footerLogoImageUrl
      emailLogoImageUrl
      receiptLogoImageUrl
      enableBuyerClaimAll
      enableBranding
      footerBgColor
      buttonText
      buttonTextColor
      buttonBgColor
      taxRate
      embedId
      embed {
        id
        name
        type
      }
      campaignId
      p2pProgramId
      cartTimeoutSeconds
      venueName
      status
      enablePublicGuestList
      sendTicketsWithConfirmationEmail
      googleAnalyticsKey
      hasActivePromo
      venueAddress {
        street
        street2
        city
        state
        zip
        country
      }
      ticketDefinitions {
        id
        name
        sortIndex
        price
        description
        remainingCount
        showRemainingQuantity
      }
      organization {
        id
        name
        currencyCode
        defaultPaymentGateway {
          id
          backendName
        }
      }
      ticketEmbedSettings {
        showEventBanner
        showEventTime
        showEventLocation
        showEventImage
        showEventDescription
        theme
      }
      guestDetailsSettings {
        salutation
        firstName
        lastName
        phone
        email
        address1
        address2
        city
        state
        zip
        country
        companyName

        salutationOptions {
          text
          value
        }

        salutationRequired
        phoneRequired
        address1Required
        address2Required
        cityRequired
        stateRequired
        zipRequired
        companyNameRequired
        countryRequired
      }
    }
  }
`;

export const EVENT_SPONSORS: any = gql`
  query EventSponsors($id: UUID, $slug: String, $draftOnly: Boolean) {
    event(id: $id, slug: $slug, draftOnly: $draftOnly) {
      sponsorTiers {
        name
        sponsors {
          id
          name
          webUrl
          imageUrl
        }
      }
    }
  }
`;
